import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "zina-dogi-react";
import "./notification_alert_modal.scss";

const SEEN_KEY = "notification_seen_alert";

const seenToken = alert => `${alert.id}_${alert.updated_at || ""}`;

export const hasSeenAlert  = alert => localStorage.getItem(SEEN_KEY) === seenToken(alert);
export const markAlertAsSeen = alert => localStorage.setItem(SEEN_KEY, seenToken(alert));

const NotificationAlertViewModal = ({ isOpen, alert, onClose }) => {
    if (!alert) return null;

    const type = (alert.type || alert.level || "info").toLowerCase();

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="lg" centered className="notification-alert-view-modal">
            <ModalHeader toggle={onClose}>
                Notification Alert
            </ModalHeader>
            <ModalBody>
                <div className={`notification-alert-modal__preview-box alert-preview--${type}`}>
                    <div className="notification-alert-modal__preview-header">
                        <strong>{alert.title}</strong>
                    </div>
                    <div className="notification-alert-modal__preview-body">
                        <p style={{ whiteSpace: "pre-line", marginBottom: (alert.start_date || alert.end_date) ? "0.5rem" : 0 }}>
                            {alert.message}
                        </p>
                        {(alert.start_date || alert.end_date) && (
                            <small className="text-muted">
                                {alert.start_date && `From: ${alert.start_date.split("T")[0]}`}
                                {alert.start_date && alert.end_date && " — "}
                                {alert.end_date && `Until: ${alert.end_date.split("T")[0]}`}
                            </small>
                        )}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onClose}>Ok</Button>
            </ModalFooter>
        </Modal>
    );
};

export default NotificationAlertViewModal;
